import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import DefaultLoader from "react-loader-spinner";
import CONFIG from '../../config';
import { Loader } from 'google-maps';
import { MdClose } from 'react-icons/md';

const MapContainer = styled.div`
    width: 100%;
    height: 100%;
    .gmnoprint {
        display: none !important;
    }
`;

const LoaderContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const MapSugesstionInput = styled.input`
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin: 10px 0 0 0;
    width: 300px;
`;

const MapModal = ({ value, loading, showModal, handleOk, handleCancel, isArabic }) => {

    const [defaultLoading, setDefaultLoading] = useState(true);
    const [coordinates, setCoordinates] = useState({});
    const [address, setAddress] = useState('');

    useEffect(() => {
        let defaultValue = {};
        if (value) {
            defaultValue = value;
            setCoordinates(value.coordinates);
            setAddress(value.address);
        } else {
            defaultValue = {address: 'Click the map to get Address!', coordinates: {lat: 25.2048, lng: 55.2708}};
        }
        initializeMap(defaultValue);

        setTimeout(() => {
            setDefaultLoading(false);
        }, 2000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const initializeMap = async (defaultValue) => {
        const loader = new Loader(CONFIG.mapKey, {libraries: ['places']});

        const google = await loader.load();
        const map = new google.maps.Map(document.getElementById('map'), {
            center: defaultValue.coordinates,
            zoom: 10
        });
        
        const input = document.getElementById("pac-input");
        const searchBox = new google.maps.places.SearchBox(input);
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

        map.addListener("bounds_changed", () => {
          searchBox.setBounds(map.getBounds());
        });
  
        let infoWindow = new google.maps.InfoWindow({
            content: defaultValue.address,
            position: defaultValue.coordinates
        });
        infoWindow.open(map);
      
        let markers = [];
        searchBox.addListener("places_changed", () => {
            const places = searchBox.getPlaces();
            if (places.length === 0) {
                return;
            }

            markers.forEach((marker) => {
                marker.setMap(null);
            });
            markers = [];

            const bounds = new google.maps.LatLngBounds();

            places.forEach((place) => {
                if (places.length === 1) {
                    infoWindow.close();
                    let temp = place.geometry.location.toJSON();
                    setCoordinates(temp);

                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({ 'location': { lat: temp.lat, lng: temp.lng } }, (results, status) => {
                        if (status === 'OK') {
                            if (results[0]) {
                                setAddress(results[0].formatted_address);
                                infoWindow = new google.maps.InfoWindow({ position: temp });
                                infoWindow.setContent(JSON.stringify( results[0].formatted_address ));
                                infoWindow.open(map);
                            } else {
                                window.alert('No results found');
                            }
                        } else {
                            window.alert('Geocoder failed due to: ' + status);
                        }
                    });
                }

                if (!place.geometry || !place.geometry.location) {
                    console.log("Returned place contains no geometry");
                    return;
                }

                const icon = {
                    url: place.icon,
                    size: new google.maps.Size(71, 71),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(17, 34),
                    scaledSize: new google.maps.Size(25, 25),
                };

                markers.push(
                    new google.maps.Marker({
                        map,
                        icon,
                        title: place.name,
                        position: place.geometry.location,
                    })
                );
                if (place.geometry.viewport) {
                    bounds.union(place.geometry.viewport);
                } else {
                    bounds.extend(place.geometry.location);
                }
            });
            map.fitBounds(bounds);
        });

        map.addListener("click", (mapsMouseEvent) => {
            infoWindow.close();
            let temp = mapsMouseEvent.latLng.toJSON();
            setCoordinates(temp);

            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ 'location': { lat: temp.lat, lng: temp.lng } }, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        setAddress(results[0].formatted_address);
                        infoWindow = new google.maps.InfoWindow({ position: temp });
                        infoWindow.setContent(JSON.stringify( results[0].formatted_address ));
                        infoWindow.open(map);
                    } else {
                        window.alert('No results found');
                    }
                } else {
                    window.alert('Geocoder failed due to: ' + status);
                }
            });
        });
    };

    return (
        <div>
            <div className="modal" style={{display: showModal ? 'block': '', overflow: 'scroll'}}>
                <div className="modal-dialog modal-dialog-centered" style={{minHeight: 'calc(100% - 0rem)'}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Select Co-ordinates</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel}>
                                <MdClose style={{color: '#121180'}} className="fa-lg" />
                            </button>
                        </div>
                        <div className="modal-body" style={{padding: '0.7rem'}}>
                            <div className="d-flex flex-column justify-content-around align-items-center" style={{height: '300px', overflow: 'scroll'}}>
                                {defaultLoading && <LoaderContainer><DefaultLoader type="ThreeDots" color="#2d207d" height={20} width={20} /></LoaderContainer>}
                                <MapSugesstionInput
                                    id="pac-input"
                                    type="text"
                                    placeholder="Search your location"
                                    style={{
                                        visibility: defaultLoading ? 'hidden' : 'visible',
                                        height: defaultLoading ? 0 : 'auto'
                                    }}
                                />
                                <MapContainer id="map" style={{
                                    visibility: defaultLoading ? 'hidden' : 'visible'
                                }} />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light font-weight-bold" onClick={handleCancel}>Close</button>
                            <button type="button" disabled={Object.keys(coordinates).length === 0} className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={() => handleOk({address, coordinates})}>Ok</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export { MapModal };